import React from "react";
import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import RelayCodingImg from "../../assets/event-images/relay-coding.jpg";

const relayCoding = {
  image: RelayCodingImg,
  description:
    "Join us for Relay Coding, the ultimate team coding challenge! Collaborate, code in turns, and solve problems seamlessly to outpace the competition. Teamwork and speed are the keys to victory!",
  type: "Technical Event",
  eventName: "Relay Coding",
  dateTime: "March 01, 2:00PM - 3:30PM",
  venue: "IT-443",
  rules: [
    "Team should consist of 3 members.", 
"Challenges will be conducted on hackerrank.", 
"Atleast one member in a team should have a hackerrank account.",
"Computers will be provided but Incase of technical difficulties, participants are requested to bring their personal laptop.",
"All programming languages are accepted.", 
"Questions will be of Easy, Medium and Hard.",
"Event will be conducted as 2 rounds.", 
"Round 1:Each member of a team should solve an individual problem", 
"Round 2:The team will solve a single problem, taking turns.",
"The team that solves the challenge in the shortest time wins."
],

  firstprize: 1000,
  secondprize: 500,
  thirdprize: 0,
  contact: [
    {
      name: "Sanjith Sivendra",
      phoneNo: "8344449586",
    },
    {
      name: "Thiageshwaran S",
      phoneNo: "9080513837",
    },
  ],
};

const RelayCoding = () => {
  return <SingleEventPage eventDetails={relayCoding} />;
};

export default RelayCoding;
